import { deepCopy } from './common'
import { validateCustomFileFormat } from '../views/form/widgets/upload/uploadFormat'
import { validateWebsiteError } from '../views/form/widgets/submitSuccessConfig'
import { judgeAddressSettingError } from '../views/form/widgets/address/cpcd'
import { SystemFieldCodeMap } from '@/utils/config'

/**
 * 设计器配置转换成数据库可保存的记录
 */
export function schemaToRecord(schema_, fieldCodes, store) {
  const schema = deepCopy(schema_)
  const globalConfig = {}
  const formViewFields = []
  const fieldsObj = deepCopy(store.getState().formSetting.fieldsObj)
  const validateItem = item => {
    if (item.hasOwnProperty('disabledEndTime') || item.hasOwnProperty('disabledStartTime')) {
      if (item.disabledStartTime.show && !item.disabledStartTime.time) {
        return `【${item.title}】开始时间不能为空`
      } else if (item.disabledEndTime.show && !item.disabledEndTime.time) {
        return `【${item.title}】结束时间不能为空`
      }
    }
    if ('popUp' in item && item.popUp.show) {
      if (!item.popUp.title.trim()) {
        return `【${item.title}】弹窗标题不能为空`
      }
      if (!item.popUp.content.trim()) {
        return `【${item.title}】弹窗正文不能为空`
      }
    }
    if ('widget' in item && item.widget === 'associatedRecord') {
      if (!item.extraTable) {
        return `请选择【${item.title}】关联表`
      }
      if (!Array.isArray(item.otherField)) {
        return `请选择【${item.title}】显示字段至少一项`
      }
      if (item.otherField.length === 0) {
        return `请选择【${item.title}】显示字段至少一项`
      }
    } else if ('widget' in item && ['associatedType', 'associatedGroupType'].includes(item.widget)) {
      if (!item.userType || (Array.isArray(item.userType) && item.userType.length === 0)) {
        return `请选择至少一项【${item.title}】`
      }
    } else if (item.widget === 'upload' && item.fileType === 'custom') {
      const fileError = validateCustomFileFormat(item.fileFormat)
      if (fileError) {
        return fileError
      }
    } else if (item.widget === 'address') {
      const addrenssError = judgeAddressSettingError(item.default)
      if (addrenssError) {
        return '【' + item.title + '】' + addrenssError
      }
    }
    if (item.widget === 'upload') {
      if (!item.fileSize) {
        item.fileSize = 500
      }
      if (!item.max) {
        item.max = 1
      }
    }
    if (item.extraTable && 'otherField' in item && item.extraTable in fieldsObj && Array.isArray(item.otherField)) {
      item.tablePkey = item.extraTable
      const fields = fieldsObj[item.extraTable]
      const f = []
      item.otherField.forEach(fv => {
        const field = fields.find(f => f.value === fv)
        if (field) {
          f.push({ fieldType: field.type, fieldCode: fv })
        }
      })
      item.fields = f
    }
    return ''
  }
  for (const k in schema) {
    if (k === 'properties') {
      for (const prop in schema[k]) {
        const item = schema[k][prop]
        let error = validateItem(item)
        if (error) {
          return error
        }
        if (item.widget === 'radio') {
          item.widget = 'customRadio'
        } else if (item.widget === 'select') {
          item.widget = 'customSelect'
        } else if (item.widget === 'multiSelect') {
          item.widget = 'customMultiSelect'
        } else if (item.widget === 'checkboxes') {
          item.widget = 'customCheckboxes'
        }
        const groupId = judgeObject(item, prop)
        if (groupId) {
          const object = {}
          object[prop] = { ...item }
          const ret = dealObject(item, fieldCodes, validateItem, groupId, { object })
          if (ret.error) {
            return ret.error
          }
          formViewFields.push(...ret.list)
        } else {
          const obj = getToTableSchema(item, fieldCodes, prop)
          formViewFields.push(obj)
        }
      }
    } else if (k === 'submitSuccessPage') {
      let error = ''
      if (
        schema.submitSuccessPage['key'] === 'website' &&
        (error = validateWebsiteError(schema.submitSuccessPage['value']))
      ) {
        return error
      } else if (schema.submitSuccessPage['key'] === 'download') {
        if (!Array.isArray(schema.submitSuccessPage['value'])) {
          return '请上传文档'
        }
        if (schema.submitSuccessPage['value'].length === 0) {
          return '请上传文档'
        }
        if (schema.submitSuccessPage['value'].find(item => item.status === 'uploading')) {
          return '文件还未上传完毕，请稍后'
        }
      }
      globalConfig[k] = schema[k]
    } else if (k === 'labelWidth') {
      globalConfig[k] = schema[k] ? schema[k] || 80 : 80
    } else {
      globalConfig[k] = schema[k]
    }
  }
  return { globalConfig: globalConfig, formViewFields }
}

// 判断是否是对象
function judgeObject(item, k) {
  let groupId = ''
  if (item.type === 'object') {
    if (!item.groupId) {
      groupId = k
      item['groupId'] = groupId
    } else {
      groupId = item.groupId
    }
  }
  return groupId
}

// 处理对象
function dealObject(item, fieldCodes, validateItem, groupId, extraProps = {}) {
  const ret = { error: '', list: [] }
  for (const k_ in item.properties) {
    const item_ = item.properties[k_]
    const error = validateItem(item_)
    if (error) {
      ret.error = error
      return ret
    }
    const subGroupId = judgeObject(item_, k_)
    if (subGroupId) {
      const subRet = dealObject(item_, fieldCodes, validateItem, subGroupId, extraProps)
      if (subRet.error) {
        return subRet
      }
      ret.list.push(...subRet.list)
    } else {
      item_['orginCode'] = k_
      const obj = getToTableSchema(item_, fieldCodes, k_, extraProps)
      extraProps = {}
      obj['fieldGroup'] = groupId
      ret.list.push(obj)
    }
  }
  return ret
}

// 转换为数据库存储的schema
function getToTableSchema(item, fieldCodes, prop, extraProps) {
  const enums = []
  const obj = {}
  obj['fieldType'] = schemaFiledsTypeForRecord(item)
  obj['fieldCode'] = item.code || (fieldCodes.includes(prop) ? prop : '')
  // 浦江论坛定制code
  if (
    [
      'bventId',
      'sort',
      'unit', // 论坛承办单位
      'schedule', // 论坛议程
      'forumtime', // 论坛时间
      'attendeeType', // 论坛参会ID
      'agendaTime', // 议程时间
      'unitType', // 承办单位类别
      'speakerCn', // 议程演讲嘉宾（中文）
      'speakerEn', // 议程演讲嘉宾（英文）
      'topicCn', // 议程主题（中文）
      'topicEn' // 议程主题（英文）
    ].includes(prop)
  ) {
    obj['fieldCode'] = prop
  }
  if (!obj['fieldCode'] && item.code && SystemFieldCodeMap.find(v => v.value === item.code)) {
    // 系统字段
    obj['fieldCode'] = item.code
  }
  const defaultOption = { ...item, ...extraProps }
  obj['defaultOption'] = defaultOption
  if ('enum' in item) {
    item['enum'].forEach((em, index) => {
      enums.push({
        code: em,
        optionDescribe: item['enumNames'][index]
      })
    })
  }

  obj['formFieldMultiLanguages'] = [
    {
      fieldName: item['title'],
      fieldOption: JSON.stringify(enums),
      language: 'zh-CN'
    }
  ]
  return obj
}

// 简单输入框、输入框 fieldType : string
// 编辑框 fieldType : textarea
// 日期选择 fieldType : date
// 数字输入框 fieldType : number
// 是否选择 fieldType : boolean
// 单选 fieldType : select
// 多选 fieldType : select				//新增表格视图填写值时，传过来的值为数组
// HTML fieldType : html
// 日期范围 fieldType : dateTime
// 带滑动条 fieldType : number
// 图片展示、颜色选择 fieldType : string
// 关联其他记录 fieldType : relationRecord
// 关联其他用户 fieldType : relationUser
// 关联参会团体 fieldType : relationOrganization
// 文件 fieldType : file
export function schemaFiledsTypeForRecord(item) {
  const type = item.type
  const format = 'format' in item ? item.format : ''
  const widget = 'widget' in item ? item.widget : ''
  if (type === 'string') {
    if (['date', 'dateTime', 'time'].includes(format)) {
      return 'date'
    } else if (format === 'textarea') {
      return format
    } else if (['select', 'radio', 'customSelect', 'customRadio', 'customNationality'].includes(widget)) {
      return 'select'
    } else if (widget === 'html') {
      return 'html'
    } else if (widget === 'associatedType') {
      return 'relationUser'
    } else if (widget === 'associatedGroupType') {
      return 'relationOrganization'
    }
  } else if (type === 'array') {
    const widgetMapForRecord = {
      multiSelect: 'select',
      checkboxes: 'select',
      customMultiSelect: 'select',
      customCheckboxes: 'select',
      associatedRecord: 'relationRecord',
      upload: 'file',
      uploadPicture: 'file',
      passport: 'file',
      address: 'address',
      idCard: 'idCard',
      phoneNumber: 'phoneNumber'
    }
    return widgetMapForRecord[widget]
  } else if (type === 'range') {
    return 'dateTime'
  }
  return type
}

/**
 * 保存记录转换成设计器可用的schema
 */
export function recordToSchema(recordObj) {
  const fieldCodes = []
  const obj = {}
  const groupSchema = {}
  if (!recordObj) {
    return obj
  }
  if (!('type' in recordObj)) {
    return obj
  }
  for (const k in recordObj) {
    if (k !== 'formViewFields') {
      obj[k] = recordObj[k]
    } else {
      const properties = {}
      for (let i = 0, len = recordObj.formViewFields.length; i < len; i++) {
        const item = recordObj.formViewFields[i]
        fieldCodes.push(item.fieldCode)
        const defaultOption = JSON.parse(item.defaultOption) || {}

        // 允许重复字段处理（switch未选中时，后端需要为true）
        const isRepeatKeys = ['email', 'mobile']
        if (isRepeatKeys.includes(item.fieldCode)) {
          defaultOption.repeat = !defaultOption?.repeat
        }
        if ('object' in defaultOption) {
          const object = defaultOption.object
          const keys = Object.keys(object)
          properties[keys[0]] = object[keys[0]]
        }
        if (item.fieldGroup) {
          groupSchema[defaultOption.orginCode] = { fieldCode: item.fieldCode, ...defaultOption }
          continue
        }

        if (defaultOption.type === 'range' && !defaultOption.widget) {
          defaultOption.widget = 'customDateRange'
        }
        // 征文摘要内容字段
        if (item.fieldCode === 'abstractContent' && defaultOption.widget !== 'richText') {
          // console.log(JSON.parse(JSON.stringify(defaultOption)), 'defaultOption', item.fieldCode)
          defaultOption.widget = 'richText'
          delete defaultOption.format
        }
        if (SystemFieldCodeMap.find(s => s.value === item.fieldCode)) {
          defaultOption.code = item.fieldCode
        }
        properties[item.fieldCode] = defaultOption
      }
      obj['properties'] = properties
    }
  }
  return { value: obj, fieldCodes, groupSchema }
}

export function dealTableFields(res, language) {
  const list = []
  if (Array.isArray(res)) {
    res.forEach(item => {
      let field
      if (language === 'en-US') {
        field = item.formFieldMultiLanguages.find(f => f.language === 'zh-CN') // 在没有标准多语言之前暂时先用中文的字段名称
      } else {
        field = item.formFieldMultiLanguages.find(f => f.language === language)
      }
      if (field) {
        list.push({
          label: field.fieldName,
          value: item.fieldCode,
          type: item.fieldType
        })
      }
    })
  }
  return list
}

/**
 * 关联记录表查询 字段集合条件
 */
export function recordTableAssociatedFields(fields, showFields) {
  if (!Array.isArray(fields)) {
    return { columns: [], pfields: [] }
  }
  const cs = []
  const pfields = []
  for (let i = 0, len = fields.length; i < len; i++) {
    const item = fields[i]
    if (!showFields.includes(item.value)) {
      continue
    }
    const key = item.type + '_' + item.value
    const c = { title: item.label, dataIndex: key, key: key, fieldType: item.type, width: 150 }
    if (item.type === 'file') {
      c['render'] = v => {
        return (
          Array.isArray(v) && (
            <div>
              {v.map(v_ => {
                return (
                  <span key={v_.fileId} style={{ marginRight: '10px' }}>
                    {v_.fileName + v_.extension}
                  </span>
                )
              })}
            </div>
          )
        )
      }
    }
    cs.push(c)
    pfields.push({ fieldType: item.type, fieldCode: item.value })
  }
  return { columns: cs, pfields }
}
